export interface MenuSourcePage {
  id: string;
  title: string;
  sections: string[];
  imageUrl: string;
}

export const menuSourcePages: MenuSourcePage[] = [
  {
    id: 'cover',
    title: 'Original Menu Cover',
    sections: ['Cover'],
    imageUrl: new URL('../../image/IMG_9426.jpeg', import.meta.url).href,
  },
  {
    id: 'breakfast',
    title: 'Breakfast Page',
    sections: ['Breakfast'],
    imageUrl: new URL('../../image/IMG_9427.jpeg', import.meta.url).href,
  },
  {
    id: 'arabian-foods',
    title: 'Arabian Foods, Fish, and Stick',
    sections: ['Arabian Foods', 'Fish', 'Stick'],
    imageUrl: new URL('../../image/IMG_9428.jpeg', import.meta.url).href,
  },
  {
    id: 'beef-extra',
    title: 'Beef and Extra',
    sections: ['Beef', 'Extra'],
    imageUrl: new URL('../../image/IMG_9429.jpeg', import.meta.url).href,
  },
  {
    id: 'burger-salad',
    title: 'Burger, Sandwich, Salad, and Vegetable',
    sections: ['Burger & Sandwich', 'Salad & Vegetable'],
    imageUrl: new URL('../../image/IMG_9430.jpeg', import.meta.url).href,
  },
  {
    id: 'spaghetti-soup',
    title: 'Spaghetti, Rice, Penne, and Soup',
    sections: ['Spaghetti / Rice / Penne', 'Soup'],
    imageUrl: new URL('../../image/IMG_9431.jpeg', import.meta.url).href,
  },
  {
    id: 'pizza',
    title: 'Pizza Page',
    sections: ['Pizza'],
    imageUrl: new URL('../../image/IMG_9432.jpeg', import.meta.url).href,
  },
  {
    id: 'drinks',
    title: 'Juices, Hot Drinks, and Soft Drinks',
    sections: ['Juice', 'Hot Drinks', 'Soft Drinks'],
    imageUrl: new URL('../../image/IMG_9433.jpeg', import.meta.url).href,
  },
];
